import { useTranslation } from "react-i18next";

const Address = () => {
    const { t } = useTranslation();
    return (
        <section className="relative open-sans pt-[90px] xl:pt-[160px]">
            <div className="relative z-10 max-w-[1220px] xl:mx-auto mx-[20px]">
                <div className="rounded-[20px] relative overflow-hidden z-0">
                    <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3352.9698159056948!2d8.535832976379684!3d47.37138617116929!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47900a012ecc131b%3A0xea5a1be5b74cd8b!2sBahnhofstrasse%2037%2C%208001%20Z%C3%BCrich%2C%20Switzerland!5e1!3m2!1sen!2sua!4v1748526459560!5m2!1sen!2sua" width="100%" height="365px" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
                <div className="md:absolute relative z-10 md:w-[496px] w-[100%] md:py-[10px] sm:px-[20px] p-[13px] rounded-[10px] bg-[#0C2780CC] backdrop-blur-[3px] md:bottom-[20px] md:mt-0 mt-[15px] md:left-[20px] sm:text-[16px] text-[14px] text-[#fff] font-[300]">
                    <p className="font-[600]">
                        {t('about.address.address')}
                    </p>
                    <p className="my-[8px]">
                        Bahnhofstrasse 37, 8001, Zürich, Switzerland
                    </p>
                    <p>
                        <span className="font-[600]">
                            LEI:
                        </span> 506700YEL719Z2T05K30
                    </p>
                </div>
            </div>
        </section>
    )
};

export default Address;
